import { AMAZON } from '@/constants/amazon'
import { isValidPostalCode } from '@/utils'
import { isEmpty } from 'lodash'
import deliveryFeeOptimizationMixin from '@/mixins/deliveryFeeOptimization'
import { PAYMENT_METHOD } from '@/constants'

export default {
  mixins: [deliveryFeeOptimizationMixin],
  data() {
    const user = this.$store.state.auth.user || {}
    const date = user.birth ? new Date(user.birth * 1000) : null

    let postalCode = user.postal_code

    if (user.postal_code && !user.postal_code.includes(this.$t('common.hyphenSeparator'))) {
      const _code = user.postal_code.split('')
      _code.splice(3, 0, this.$t('common.hyphenSeparator'))
      postalCode = _code.join('')
    }

    const [postalCode1, postalCode2] = postalCode?.split(this.$t('common.hyphenSeparator')) || ['', '']

    const form = {
      memberInformation: {
        lastName: user.name01 || '',
        firstName: user.name02 || '',
        lastNameKana: user.kana01 || '',
        firstNameKana: user.kana02 || '',
        birthdayYear: date ? this.$date.getYear(date) : null,
        birthdayMonth: date ? this.$date.getMonth(date) + 1 : null,
        birthdayDay: date ? this.$date.getDate(date) : null,
        sex: user.sex?.id || null,
        email: user.email || '',
        emailConfirm: user.email || '',
        password: '' || user.password,
        passwordConfirm: '' || user.password,
        postalCode1: postalCode1 || '',
        postalCode2: postalCode2 || '',
        prefecture: user.pref?.id || null,
        municipality: user.addr01 || '',
        address: user.addr02 || '',
        buildingApartmentName: user.addr03 || '',
        phoneNumber: this.Utils.helper.getOnlyNumber(user.phone_number),
        companyName:
          this.corporateFlag || !user.business_account_flag
            ? user.company_name || ''
            : user.name01 + (user.name02 || ''),
        companyNameKana: this.corporateFlag ? '' : (user.kana01 || '') + (user.kana02 || ''),
        businessAccountFlag: user.business_account_flag || false,
        isChangePostalCode: false,
      },
      shippingInformation: {
        addressId: null,
        deliveryDestination: this.Constants.DELIVERY_DESTINATION.SAME_MEMBER,
        lastName: '',
        firstName: '',
        lastNameKana: '',
        firstNameKana: '',
        postalCode1: '',
        postalCode2: '',
        prefecture: null,
        municipality: '',
        address: '',
        buildingApartmentName: '',
        phoneNumber: '',
        shippingMethod: '',
        desiredDeliveryDay: this.$date
          .add(this.$date.startOfDay(new Date()), {
            days: this.addDayByMinDeliveryDate(true),
          })
          .getTime(),
        desiredDeliveryTimeZone: null,
        delivery_note_id: null,
        bundled_flag: null,
        companyName: '',
        companyNameKana: '',
        cooling_off_flag: false,
        delivery_service_name: null,
        bundle_possible_flag: false,
        flat_rate_delivery_fee: null,
        isChangePostalCode: false,
        deliveryTimes: null,
        isAvailableDeliveryTime: false,
        delivery_id: null,
        time_note_disable_flag: false,
      },
      subscription: {
        deliveryPattern: this.Constants.DELIVERY_PATTERN.MONTHLY_DATE_SPECIFICATION,
        deliveryInterval: 1,
        secondDeliveryDate: 0,
      },
      paymentInformation: {
        methodOfPayment: this.$session[AMAZON.ACCESS_TOKEN_029] ? this.Constants.PAYMENT_METHOD.AMAZON : undefined, // default no choose payment method
        cardNumber: '',
        dateOfExpiredMonth: '',
        dateOfExpiredYear: '',
        cardHolder: null,
        securityCode: '',
        numberOfPayment: this.Constants.NUMBER_OF_PAYMENT.BULK,
        cardSeq: null,
        amazonCard: null,
        isPaymentShow: true,
      },
      purchaseItems: [],
      placeFindThisProduct: '',
      advertisement_remarks: '',
      deliveryPaymentMethodList: [],
      deliveryMethodList: [],
      visibleDeliveryPaymentMethods: [],
      bundledAvailableFlag: false,
      isSubmitTrim: false,
    }
    const popupName = this.$route.query.popup

    const isPopupName = popupName && Object.values(this.Constants.POPUP_NAME).includes(popupName)

    const postalCodeValidator = async (rule, value, callback, section) => {
      const postalCode01 = this.form[section].postalCode1
      const postalCode02 = this.form[section].postalCode2

      if (postalCode01 && postalCode02 && isValidPostalCode({ postalCode01, postalCode02 })) {
        callback()
      } else if (
        (!postalCode01 && !postalCode02) ||
        !postalCode01 ||
        postalCode01.length < 3 ||
        !postalCode02 ||
        postalCode02.length < 4
      ) {
        callback(new Error(this.$t('common.validate.cmn-err-001', [this.$t('common.validate.field.postalCode')])))
      }
    }

    return {
      form: this.$_.cloneDeep(form),
      defaultForm: this.$_.cloneDeep(form),
      addressDialog: isPopupName && popupName === this.Constants.POPUP_NAME.ADDRESS,
      addresses: [],
      cardDialog: isPopupName && popupName === this.Constants.POPUP_NAME.CARD,
      cards: [],
      deliveryMethods: [],
      deliveryMinDate: null,
      section: {
        memberInfo: 'memberInfo',
        shippingInfo: 'shippingInfo',
        paymentInfo: 'paymentInfo',
      },

      rules: {
        'memberInformation.lastName': [
          this.Utils.validate.required(this.$t('common.validate.field.lastName')),
          this.Utils.validate.shiftjis(this.$t('common.validate.shiftjis')),
        ],

        'memberInformation.firstName': [
          this.Utils.validate.required(this.$t('common.validate.field.firstName')),
          this.Utils.validate.shiftjis(this.$t('common.validate.shiftjis')),
        ],

        'memberInformation.lastNameKana': [
          this.Utils.validate.required(this.$t('common.validate.field.lastNameKana')),
          this.Utils.validate.kanaFormat(this.$t('common.validate.field.lastNameKana')),
        ],

        'memberInformation.firstNameKana': [
          this.Utils.validate.required(this.$t('common.validate.field.firstNameKana')),
          this.Utils.validate.kanaFormat(this.$t('common.validate.field.firstNameKana')),
        ],

        'memberInformation.birthdayYear': [
          this.Utils.validate.numberFormat(this.$t('common.validate.field.birthdayYear')),
          this.Utils.validate.requiredSelect(this.$t('common.validate.field.birthdayYear')),
        ],

        'memberInformation.birthdayMonth': [
          this.Utils.validate.numberFormat(this.$t('common.validate.field.birthdayMonth')),
          this.Utils.validate.requiredSelect(this.$t('common.validate.field.birthdayMonth')),
        ],

        'memberInformation.birthdayDay': [
          this.Utils.validate.numberFormat(this.$t('common.validate.field.birthdayDay')),
          this.Utils.validate.requiredSelect(this.$t('common.validate.field.birthdayDay')),
        ],

        'memberInformation.sex': [this.Utils.validate.requiredSelect(this.$t('common.validate.field.sex'))],

        'memberInformation.email': [
          this.Utils.validate.required(this.$t('common.validate.field.email')),
          this.Utils.validate.emailFormat(this.$t('common.validate.field.email')),
        ],

        'memberInformation.emailConfirm': [
          this.Utils.validate.required(this.$t('common.validate.field.emailConfirm')),
          this.Utils.validate.emailFormat(this.$t('common.validate.field.emailConfirm')),
          {
            trigger: 'blur',
            validator: (_rule, value, callback) => {
              if (value !== this.form.memberInformation.email) {
                callback(
                  new Error(
                    this.$t('common.validate.cmn-err-015', [
                      this.$t('common.validate.field.email'),
                      this.$t('common.validate.field.emailConfirm'),
                    ])
                  )
                )
              } else {
                callback()
              }
            },
          },
        ],

        'memberInformation.password': !user.id
          ? [
              this.Utils.validate.required(this.$t('common.validate.field.password')),
              this.Utils.validate.password(this.$t('common.validate.field.password')),
            ]
          : [],
        'memberInformation.passwordConfirm': !user.id
          ? [
              this.Utils.validate.required(this.$t('common.validate.field.passwordConfirm')),
              this.Utils.validate.password(this.$t('common.validate.field.passwordConfirm')),
              {
                trigger: 'blur',
                validator: (_rule, value, callback) => {
                  if (value !== this.form.memberInformation.password) {
                    callback(
                      new Error(
                        this.$t('common.validate.cmn-err-015', [
                          this.$t('common.validate.field.password'),
                          this.$t('common.validate.field.passwordConfirm'),
                        ])
                      )
                    )
                  } else {
                    callback()
                  }
                },
              },
            ]
          : [],

        memberPostalCodeRule: [
          {
            validator: (rule, value, callback) => postalCodeValidator(rule, value, callback, 'memberInformation'),
            trigger: ['change', 'blur'],
          },
        ],

        'memberInformation.prefecture': [
          this.Utils.validate.requiredSelect(this.$t('common.validate.field.prefecture')),
        ],

        'memberInformation.municipality': [this.Utils.validate.required(this.$t('common.validate.field.municipality'))],

        'memberInformation.address': [this.Utils.validate.required(this.$t('common.validate.field.address'))],

        'memberInformation.phoneNumber': [
          this.Utils.validate.required(this.$t('common.validate.field.phoneNumber')),
          this.Utils.validate.numberFormat(this.$t('common.validate.field.phoneNumber')),
          this.Utils.validate.phoneFormat(),
        ],
        'memberInformation.companyName': [this.Utils.validate.required(this.$t('common.validate.field.companyName'))],
        'memberInformation.companyNameKana': [
          this.Utils.validate.required(this.$t('common.validate.field.companyNameKana')),
          this.Utils.validate.kanaFormat(this.$t('common.validate.field.companyNameKana')),
        ],
        'shippingInformation.lastName': [this.Utils.validate.required(this.$t('common.validate.field.lastName'))],

        'shippingInformation.firstName': [this.Utils.validate.required(this.$t('common.validate.field.firstName'))],

        'shippingInformation.lastNameKana': [
          this.Utils.validate.required(this.$t('common.validate.field.lastNameKana')),
          this.Utils.validate.kanaFormat(this.$t('common.validate.field.lastNameKana')),
        ],

        'shippingInformation.firstNameKana': [
          this.Utils.validate.required(this.$t('common.validate.field.firstNameKana')),
          this.Utils.validate.kanaFormat(this.$t('common.validate.field.firstNameKana')),
        ],

        shippingPostalCodeRule: [
          {
            validator: (rule, value, callback) => postalCodeValidator(rule, value, callback, 'shippingInformation'),
            trigger: ['change', 'blur'],
          },
        ],

        'shippingInformation.prefecture': [
          this.Utils.validate.requiredSelect(this.$t('common.validate.field.prefecture')),
        ],

        'shippingInformation.municipality': [
          this.Utils.validate.required(this.$t('common.validate.field.municipality')),
        ],

        'shippingInformation.address': [this.Utils.validate.required(this.$t('common.validate.field.address'))],

        'shippingInformation.phoneNumber': [
          this.Utils.validate.required(this.$t('common.validate.field.phoneNumber')),
          this.Utils.validate.numberFormat(this.$t('common.validate.field.phoneNumber')),
          this.Utils.validate.phoneFormat(),
        ],
        'shippingInformation.companyName': [this.Utils.validate.required(this.$t('common.validate.field.companyName'))],
        'shippingInformation.companyNameKana': [
          this.Utils.validate.required(this.$t('common.validate.field.companyNameKana')),
          this.Utils.validate.kanaFormat(this.$t('common.validate.field.companyNameKana')),
        ],

        'paymentInformation.methodOfPayment': [
          this.Utils.validate.requiredSelect(this.$t('common.validate.field.methodOfPayment')),
        ],

        'paymentInformation.cardNumber': [
          this.Utils.validate.required(this.$t('common.validate.field.cardNumber')),
          this.Utils.validate.numberFormat(this.$t('common.validate.field.cardNumber')),
        ],

        'paymentInformation.dateOfExpiredMonth': [
          this.Utils.validate.required(this.$t('common.validate.field.dateOfExpiredMonth')),
          this.Utils.validate.numberFormat(this.$t('common.validate.field.dateOfExpiredMonth')),
          this.Utils.validate.numberBetween(this.$t('common.validate.field.dateOfExpiredMonth'), 1, 12),
        ],

        'paymentInformation.dateOfExpiredYear': [
          this.Utils.validate.required(this.$t('common.validate.field.dateOfExpiredYear')),
          this.Utils.validate.numberFormat(this.$t('common.validate.field.dateOfExpiredYear')),
          this.Utils.validate.numberBetween(
            this.$t('common.validate.field.dateOfExpiredYear'),
            new Date().getFullYear().toString().slice(-2),
            (new Date().getFullYear() + 10).toString().slice(-2)
          ),
        ],

        'paymentInformation.securityCode': [
          this.Utils.validate.required(this.$t('common.validate.field.securityCode')),
          this.Utils.validate.numberFormat(this.$t('common.validate.field.securityCode')),
        ],
      },
    }
  },
  computed: {
    days() {
      const daysInMonth = this.$date.getDaysInMonth(
        this.$date.set(new Date(), {
          year: this.form.memberInformation.birthdayYear,
          month: this.form.memberInformation.birthdayMonth - 1,
        })
      )

      return Array.from(Array(daysInMonth).keys()).map((index) => index + 1)
    },

    placeFindProducts() {
      return (
        this.$store.state.master.whereDidYouKnow?.map((item) => ({
          value: item.id,
          label: item.name,
        })) || []
      )
    },

    sex() {
      return (
        this.$store.state.master.sex?.map((item) => ({
          value: item.id,
          label: item.name,
        })) || []
      )
    },

    shippingMethods() {
      return this.deliveryMethods.length
        ? this.deliveryMethods?.map((item) => ({
            value: item.delivery_division_id,
            label: item.delivery_name,
          })) || []
        : this.$store.state.register.shippingMethods?.map((item) => ({
            value: item.id,
            label: item.service_name,
          })) || []
    },
    postalCodeCustomer() {
      const postalCode = this.Utils.helper.postalCode(
        this.form.memberInformation.postalCode1,
        this.form.memberInformation.postalCode2
      )
      return postalCode.length === 8 ? postalCode : null
    },
    postalCodeShipping() {
      const postalCode = this.Utils.helper.postalCode(
        this.form.shippingInformation.postalCode1,
        this.form.shippingInformation.postalCode2
      )
      return postalCode.length === 8 ? postalCode : null
    },
    postalCodeInfo() {
      const isSameMember =
        this.form.shippingInformation.deliveryDestination === this.Constants.DELIVERY_DESTINATION.SAME_MEMBER
      const active = isSameMember ? this.postalCodeCustomer : this.postalCodeShipping
      return {
        customer: this.postalCodeCustomer,
        shipping: this.postalCodeShipping,
        active,
        isValid: !!active,
      }
    },
    prefectureInfo() {
      const isSameMember =
        this.form.shippingInformation.deliveryDestination === this.Constants.DELIVERY_DESTINATION.SAME_MEMBER
      return {
        customer: this.form.memberInformation.prefecture,
        shipping: this.form.shippingInformation.prefecture,
        active: isSameMember ? this.form.memberInformation.prefecture : this.form.shippingInformation.prefecture,
      }
    },
    corporateFlag() {
      return this.$store.getters['auth/shop']?.corporate_flag
    },
  },

  watch: {
    'form.memberInformation.birthdayYear'() {
      this.checkDateFeature()
    },
    'form.memberInformation.birthdayMonth'() {
      if (!this.days.includes(this.form.memberInformation.birthdayDay)) {
        this.form.memberInformation.birthdayDay = null
      }

      this.checkDateFeature()
    },
    'form.memberInformation.birthdayDay'() {
      this.checkDateFeature()
    },
  },

  methods: {
    isMailDeliveryService() {
      const deliveryServiceShop = this.$store.getters['master/deliveryServiceShop']
      if (this.form.shippingInformation.delivery_service_id) {
        return (
          deliveryServiceShop.find((i) => i.id === this.form.shippingInformation.delivery_service_id)
            ?.time_note_disable_flag || false
        )
      }
      return deliveryServiceShop.find((i) => i.time_note_disable_flag === true)?.time_note_disable_flag || false
    },
    hasAmazonPayment() {
      if (this.deliveryPaymentMethodList?.length > 0) {
        return this.deliveryPaymentMethodList?.some((i) => i.payment_service_id === PAYMENT_METHOD.AMAZON && i.visible)
      } else {
        return this.visibleDeliveryPaymentMethods?.some(
          (i) => i.payment_service_id === PAYMENT_METHOD.AMAZON && i.visible
        )
      }
    },
    paymentMethodList() {
      const paymentMethodList =
        this.deliveryPaymentMethodList?.filter(
          (item) => item.payment_service_id !== this.Constants.PAYMENT_METHOD.CASH_ON_DELIVERY
        ) || []

      this.$nextTick(() => this.handleChangeMethodOfPayment(paymentMethodList))
      return paymentMethodList
    },
    handleChangeMethodOfPayment(paymentMethodList) {
      const paymentMethod = paymentMethodList.find(
        (item) => item.payment_id === this.form.paymentInformation.methodOfPayment
      )

      if (!isEmpty(paymentMethod) && paymentMethod?.rule_max !== null && paymentMethod?.rule_max < this.totalAmount) {
        if (this.isLoginAmazon && this.disableAmazon) {
          this.onAmazonLogout(AMAZON.ACCESS_TOKEN_029)
          this.handleError({ message: this.hintAmazon })
        }
      }
    },
    getPaymentIdByServiceId(serviceId) {
      return this.deliveryPaymentMethodList?.find((item) => item.payment_service_id === serviceId)?.payment_id
    },
    getServiceIdByPaymentId(id) {
      return this.deliveryPaymentMethodList?.find((item) => item.payment_id === id)?.payment_service_id
    },
    getIsPaymentShow() {
      const paymentMethods = this.paymentMethodList() || this.$store.state.register.paymentMethods
      return this.form.paymentInformation.isPaymentShow && paymentMethods?.length > 0
    },
    getInfoCustomer() {
      let postalCode = this.user.postal_code

      if (this.user.postal_code && !this.user.postal_code.includes(this.$t('common.hyphenSeparator'))) {
        const _code = this.user.postal_code.split('')
        _code.splice(3, 0, this.$t('common.hyphenSeparator'))
        postalCode = _code.join('')
      }

      const date = (this.user.birth && new Date(this.user.birth * 1000)) || null

      const [postalCode1, postalCode2] = postalCode?.split(this.$t('common.hyphenSeparator')) || ['', '']

      this.form.memberInformation = {
        lastName: this.user.name01 || '',
        firstName: this.user.name02 || '',
        lastNameKana: this.user.kana01 || '',
        firstNameKana: this.user.kana02 || '',
        birthdayYear: date ? this.$date.getYear(date) : null,
        birthdayMonth: date ? this.$date.getMonth(date) + 1 : null,
        birthdayDay: date ? this.$date.getDate(date) : null,
        sex: this.user.sex?.id || this.Constants.SEX.MALE,
        email: this.user.email || '',
        emailConfirm: this.user.email || '',
        password: this.user.password || '',
        passwordConfirm: this.user.password || '',
        postalCode1: postalCode1,
        postalCode2: postalCode2,
        prefecture: this.user.pref?.id || null,
        municipality: this.user.addr01 || '',
        address: this.user.addr02 || '',
        buildingApartmentName: this.user.addr03 || '',
        phoneNumber: this.Utils.helper.getOnlyNumber(this.user.phone_number),
        companyName: this.corporateFlag ? this.user.company_name || '' : this.user.name01 + (this.user.name02 || ''),
        companyNameKana: this.corporateFlag ? '' : this.user.kana01 + (this.user.kana02 || ''),
        businessAccountFlag: this.user.business_account_flag || false,
      }
    },

    /**
     * 配送方法選択
     * @param deliveryId 配送方法ID
     */
    async selectDeliveryMethod(deliveryId, paymentId) {
      await this.selectDeliveryFeeOptimization(
        deliveryId,
        paymentId,
        this.postalCodeShipping,
        this.form.shippingInformation.prefecture
      )
      // 配送方法
      this.form.shippingInformation.delivery_id = this.selectedDeliveryMethod.delivery_id
      this.form.shippingInformation.delivery_service_id = this.selectedDeliveryMethod.delivery_service_id
      this.form.shippingInformation.shippingMethod = this.selectedDeliveryMethod.delivery_division_id
      this.form.shippingInformation.delivery_division_name = this.selectedDeliveryMethod.delivery_division_name
      this.form.shippingInformation.delivery_service_name = this.selectedDeliveryMethod.delivery_division_name
      this.form.shippingInformation.cooling_off_flag = this.selectedDeliveryMethod.cooling_off_flag
      this.form.shippingInformation.time_note_disable_flag = this.isMailDeliveryService()

      // 配送料金
      const deliveryFee =
        this.summary.is_shipping_free === false ? this.selectedDeliveryMethod.flat_rate_delivery_fee : 0

      if (this.isCartPeriodic) {
        this.subscriptionCartsSummary.delivery_fee = String(deliveryFee)
        this.subscriptionCartsSummary.next_delivery_fee = String(deliveryFee)
      } else {
        this.normalCartsSummary.delivery_fee = String(deliveryFee)
      }

      // 支払方法
      this.deliveryPaymentMethodList = this.selectedDeliveryMethod?.payment
      if (this.deliveryPaymentMethodList?.length > 0) {
        this.form.paymentInformation.isPaymentShow = this.deliveryPaymentMethodList?.length > 0

        // 支払方法初期設定 (支払方法を優先順で設定)
        const credit = this.deliveryPaymentMethodList.find(
          (item) => item.payment_service_id === this.Constants.PAYMENT_METHOD.CREDIT_CARD
        )

        if (credit && this.creditCards?.length > 0) {
          // 既存会員
          const defaultCard = this.creditCards.find((card) => card.default_flag === '1') || this.creditCards[0]
          this.form.paymentInformation = {
            ...this.form.paymentInformation,
            payment_id: defaultCard.payment_id,
            card_number: defaultCard.card_no,
            card_seq: defaultCard.card_seq,
            card_holder: defaultCard.holder_name,
            expired_year: defaultCard.expire.substring(0, 2),
            expired_month: defaultCard.expire.substring(2),
          }
        } else {
          const np = this.deliveryPaymentMethodList.find(
            (item) => item.payment_service_id === this.Constants.PAYMENT_METHOD.NP
          )
          const cashOnDelivery = this.deliveryPaymentMethodList.find(
            (item) => item.payment_service_id === this.Constants.PAYMENT_METHOD.CASH_ON_DELIVERY
          )
          this.form.paymentInformation.methodOfPayment =
            credit?.payment_id ||
            np?.payment_id ||
            cashOnDelivery?.payment_id ||
            this.deliveryPaymentMethodList[0]?.payment_id
        }
      }

      // 同梱可能配送会社フラグ
      if (!this.bundledAvailableFlag) {
        this.form.shippingInformation.bundled_flag = false
      }

      // 配送希望時間帯
      this.form.shippingInformation.isAvailableDeliveryTime = this.selectedDeliveryMethod.is_available_delivery_time
      this.form.shippingInformation.deliveryTimes = this.selectedDeliveryMethod.delivery_times || null
      this.$store.commit('cart/SET_IS_NOT_BUNDLED_REMOTE_ISLAND', !this.bundledAvailableFlag)
      this.form.shippingInformation.desiredDeliveryTimeZone = this.selectedDeliveryMethod.desired_delivery_time_zone

      // 最短配送予定日
      if (this.selectedDeliveryMethod.desired_delivery_day && this.selectedDeliveryMethod.delivery_min_date) {
        this.form.shippingInformation.desiredDeliveryDay = this.$date
          .add(this.$date.startOfDay(this.selectedDeliveryMethod.desired_delivery_day), {
            days: this.addDayByMinDeliveryDate(),
          })
          .getTime()
        this.deliveryMinDate = this.$date
          .add(this.$date.startOfDay(this.selectedDeliveryMethod.delivery_min_date), {
            days: this.addDayByMinDeliveryDate(),
          })
          .getTime()
      }
      return
    },

    /**
     * 配送方法取得
     * @param postalCode 郵便番号
     * @param prefId 都道府県ID
     */
    async getDeliveryMethod(postalCode, prefId) {
      const loading = this.$loading({
        lock: true,
      })
      try {
        if (postalCode && prefId && postalCode.length === 8) {
          if (this.purchase.items.length <= 0) {
            return
          }

          // 配送費用最適化処理
          const params = {
            postal_code: postalCode,
            pref_id: prefId,
            business_account_flag:
              this.user?.business_account_flag || this.form.memberInformation?.businessAccountFlag || false,
            bundled_flag: this.form.shippingInformation?.bundled_flag,
            cooling_off_flag: false,
            order_item_list: this.purchase.items,
          }

          await this.getDeliveryFeeOptimization(params)
          if (this.optimizedDeliveryMethodList.delivery_methods.length > 0) {
            // 配送費用最適化配送業者リスト
            this.deliveryMethods = this.optimizedDeliveryMethodList.delivery_methods
            this.bundledAvailableFlag = this.optimizedDeliveryMethodList.bundled_available_flag
            // プロパティに配送方法各種情報設定
            this.selectDeliveryMethod(
              this.deliveryMethods[0]?.delivery_id,
              this.form.paymentInformation.methodOfPayment
            )
          }
        } else {
          this.deliveryMethods = []
          this.form.shippingInformation.deliveryTimes = null
          this.deliveryPaymentMethodList = []
          this.deliveryMinDate = null
          this.form.shippingInformation.shippingMethod = null
          this.form.paymentInformation.isPaymentShow = false
          this.form.shippingInformation.desiredDeliveryTimeZone = null
          this.$store.commit('cart/SET_IS_NOT_BUNDLED_REMOTE_ISLAND', false)
          this.form.shippingInformation.bundled_flag = true
        }
      } catch (error) {
        this.deliveryMethods = []
        this.form.shippingInformation.deliveryTimes = null
        this.deliveryPaymentMethodList = []
        this.deliveryMinDate = null
        this.form.shippingInformation.shippingMethod = null
        this.form.paymentInformation.isPaymentShow = false
        this.form.shippingInformation.desiredDeliveryTimeZone = null
        this.$store.commit('cart/SET_IS_NOT_BUNDLED_REMOTE_ISLAND', false)
        this.form.shippingInformation.bundled_flag = true

        this.handleError(error)
      } finally {
        loading.close()
      }
      return
    },

    /**
     * Init when edit
     */
    initInfo() {
      const customer = this.$store.state.register.customer
      if (customer) {
        this.form = { ...customer }
      }
    },

    /**
     * Check date feature
     */
    checkDateFeature() {
      const { birthdayDay, birthdayMonth, birthdayYear } = this.form.memberInformation

      if (!birthdayDay || !birthdayMonth || !birthdayYear) return false

      const today = new Date()
      const birthday = new Date(birthdayYear, birthdayMonth - 1, birthdayDay)

      const isAfter = this.$date.isAfter(birthday, today)

      if (isAfter) {
        if (this.$date.getMonth(birthday) > this.$date.getMonth(today)) {
          this.form.memberInformation.birthdayMonth = 1
        }

        this.form.memberInformation.birthdayDay = 1

        this.$alert({
          message: this.$t('common.messages.selectDateFeature'),
          type: 'error',
        })

        return true
      }

      return false
    },
    addDayByMinDeliveryDate(setInitFlag = false) {
      const addDay = setInitFlag ? 3 : 0
      return this.corporateFlag ? addDay + 1 : addDay
    },
  },
}
